export const HelpTypes: IHelpTypes[] = [
	{
		helpName: "Приєднатись до команди",
		helpDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        popup: "teamPopup",
        image:"https://i.imgur.com/vz8N6wJ.jpg"
    },
    {
		helpName: "Надіслати матеріальну допомогу",
		helpDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        popup: "resPopup",
        image:"https://i.imgur.com/SsTS8WZ.jpg"
    },
    {
		helpName: "Надіслати кошти",
		helpDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        popup: "moneyPopup",
        image:"https://i.imgur.com/RC0BUmJ.jpg"
    }
	
]